import wrapInTabContentContainer from '../../../AppNavigator/TabNavigation/wrapInTabContentContainer';
import ResourcesRootScreen from './ResourcesRootScreen';
import AddNoteScreen from './AddNoteScreen';
import NoteDetailsScreen from './NoteDetailsScreen';
import NoteEditScreen from './NoteEditScreen';
import AddCareTeamMemberScreen from './AddCareTeamMemberScreen';
import EditCareTeamMemberScreen from './EditCareTeamMemberScreen';
import CareTeamMemberScreen from './CareTeamMemberScreen';

const screens = {
    ResourcesRootScreen: wrapInTabContentContainer(ResourcesRootScreen),
    AddNoteScreen: wrapInTabContentContainer(AddNoteScreen),
    NoteDetailsScreen: wrapInTabContentContainer(NoteDetailsScreen),
    NoteEditScreen: wrapInTabContentContainer(NoteEditScreen),
    AddCareTeamMemberScreen: wrapInTabContentContainer(AddCareTeamMemberScreen),
    EditCareTeamMemberScreen: wrapInTabContentContainer(EditCareTeamMemberScreen),
    CareTeamMemberScreen: wrapInTabContentContainer(CareTeamMemberScreen),
};

export { screens };
